module.exports = __webpack_public_path__ + "img/40_69_001_770.e743d71c.jpg";